export default (target, container) => {
  function textSizeToContentWidthFix (target, container, reset = false, matches = []) {
    return () => {
      if (!matches.length) matches = [...document.querySelectorAll(`${container} > ${target}`)];

      if (reset) {
        matches.map(el => {
          el.style.fontSize = '';
          el.style.lineHeight = '';
        }); 
      }
      
      matches.map(el => {
        el.style.hyphens = 'none';
        el.style['-webkit-hyphens'] = 'none';
        el.style.wordBreak = 'normal';
      });

      
      
      const toFix = matches.filter(el => el.getBoundingClientRect().width > el.closest(container).getBoundingClientRect().width);
      const fixes = toFix.map(el => {
        el.style.fontSize = `${parseInt(getComputedStyle(el)['font-size']) - 1}px`;
        el.style.lineHeight = `${parseInt(getComputedStyle(el)['line-height']) - 1}px`;
        return true;
      });
      
      matches.map(el => {
        el.style.hyphens = null;
        el.style.wordBreak = null;
        el.style['-webkit-hyphens'] = null;
      });

      // console.log(target);
      if (fixes.length > 0) textSizeToContentWidthFix(target, container, false, toFix)();
    };
  }

  window.addEventListener('load', textSizeToContentWidthFix(target, container, false));
  window.addEventListener('resize', textSizeToContentWidthFix(target, container, true));
  window.responsive('tablet', textSizeToContentWidthFix(target, container, true));
  window.responsive('mobile', textSizeToContentWidthFix(target, container, true));
};
